module.exports = __webpack_public_path__ + "img/about-bio-2.c80072e3.jpg";